import Vue from 'vue';
import { toDuration } from '@/util/date';

function timeConverter(datetime) {
  const a = new Date(datetime);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const date = a.getDate().toString().padStart(2, '0');
  const hour = a.getHours().toString().padStart(2, '0');
  const min = a.getMinutes().toString().padStart(2, '0');
  const sec = a.getSeconds().toString().padStart(2, '0');
  const time = `${date} ${month} ${year} ${hour}:${min}:${sec}`;
  return time;
}

Vue.filter('toLocalDate', (value) => {
  if (!value) return '';
  return timeConverter(value * 1000);
});

Vue.filter('toDuration', toDuration);
